module.exports = __webpack_public_path__ + "e046c691af201a2f132123a45b1c2d92.svg";